export const TabTypeMapping = {
  0: 1, // Motivational
  1: 2, // Meditation
  2: 3, // Company culture
  3: 4, // Training Documents
};

export const WellnessHeaders = {
  "Accept-version": "2.0",
  "Cache-Control":"no-cache, private"
};
